<template>
  <aside class="col-12 lg:col-4 xl:col-3 xl:pl-0 hidden lg:flex flex-col">
    <div class="py-6 mb-1">
      <!-- Top space -->
    </div>
    <div
      id="js-sticky"
      class="flex-grow-1"
    >
      <div
        id="js-sticky__aside"
        class="sidebar xl:ml-n3"
      >
        <div
          id="js-sticky__aside__inner"
          class="sidebar__inner"
        >
          <div class="tubus">
            <div class="tubus__inner bg-primary-100">
              <!-- Upper flags -->
              <div class="relative pt-5">
                <div class="shape top-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 306 21"
                    preserveAspectRatio="xMidYMin"
                    role="img"
                  >
                    <path
                      d="M27 21l9-21H18zm36 0l9-21H54zm36 0l9-21H90zm36 0l9-21h-18zm36 0l9-21h-18zm36 0l9-21h-18zm36 0l9-21h-18zm27-21l9 21 9-21z"
                      fill="#9A2E34"
                    />
                    <path
                      d="M9 21l9-21H0zm36 0l9-21H36zm36 0l9-21H72zm36 0l9-21h-18zm36 0l9-21h-18zm36 0l9-21h-18zm36 0l9-21h-18zm36 0l9-21h-18zm27-21l9 21 9-21z"
                      fill="#4F2B1B"
                    />
                  </svg>
                </div>
              </div>
              <!-- Header -->
              <div class="p-1 mb-1 mx-4 bg-primary-200 rounded-pill">
                <div class="p-1 bg-primary-100 rounded-pill">
                  <header class="py-2 px-3 text-center bg-primary-200 rounded-pill">
                    <form
                      v-if="showNameInput"
                      class="input-group bg-white border rounded-pill"
                      @submit="setMixName"
                    >
                      <input
                        id="change-mix-name-input"
                        v-model="mixName"
                        type="text"
                        class="form-control form-control-sm px-3 shadow-none border-0 rounded-pill"
                        autocomplete="off"
                        list="datalistOptions"
                        required
                      >
                      <datalist id="datalistOptions">
                        <option
                          v-for="name in defaultMixNames"
                          :key="name"
                          :value="name"
                        />
                      </datalist>
                      <div class="input-group-append m-0">
                        <VTooltip theme="baseTooltip">
                          <button
                            class="btn  btn-success p-1 font-medium rounded-pill"
                            aria-label="Confirm"
                            type="submit"
                          >
                            <i class="mi-check text-white" />
                          </button>
                          <template #popper>
                            {{ t('name_appears_on_the_label') }}
                          </template>
                        </VTooltip>
                      </div>
                    </form>
                    <div
                      v-else
                      class="flex items-center"
                    >
                      <strong
                        class="h4 mb-1 mx-1 flex-grow-1 text-danger"
                        :style="{ borderBottom: '2px solid transparent' }"
                      >
                        {{ mixName }}
                      </strong>
                      <button
                        type="button"
                        aria-label="Change mix name"
                        class="btn btn-outline-danger flex-shrink-0 p-1 border-0 rounded-circle"
                        @click="showNameInput = !showNameInput"
                      >
                        <i class="mi-pen" />
                      </button>
                    </div>
                    <div
                      class="form-row relative mb-0 items-center justify-center text-lg text-nowrap"
                    >
                      <strong class="col-auto">
                        {{ numberToCurrency(getActualMix?.totalPrice, t('currency')) }}
                      </strong>
                      <span class="col-auto">/ {{ getActualMix?.totalWeight.toFixed(0) }} g</span>
                      <div v-show="kind === 'musli' || kind === 'porridge'">
                        <VTooltip theme="checkoutTooltip">
                          <button
                            class="flex btn btn-outline-warning p-0 stretched-link m-1 rounded-circle"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="info"
                            type="button"
                            aria-label="info"
                            tabindex="-1"
                          >
                            <i class="mi-question icon-10" />
                          </button>
                          <template #popper>
                            <span>{{ t('weight_of_mix_varies') }}</span>
                          </template>
                        </VTooltip>
                      </div>
                    </div>
                    <p class="mb-0 small">
                      ({{
                        getActualMix?.pricePerPortion
                          ? `${getActualMix?.pricePerPortion.toFixed(2)} ${t('currency')}`
                          : `0 ${t('currency')}`
                      }}
                      / 100 g)
                    </p>
                  </header>
                </div>
              </div>
              <!-- Information -->
              <div
                v-show="kind === 'musli' || kind === 'porridge'"
                class="py-2 px-4 mx-4 my-2 text-sm font-bold bg-info text-white rounded shadow"
              >
                {{ t('tip') }}
              </div>
              <!-- List -->
              <ul class="list-unstyled px-4 m-0 js-component-list-desktop">
                <!-- Items -->
                <div
                  v-if="
                    getActualMix?.shouldHasBase &&
                      getActualMix?.baseItems.length === 0 &&
                      getActualMix?.nonBaseItems.length > 0
                  "
                  class="text-sm text-black"
                >
                  {{ t('first_insert_base_of_mix') }}
                </div>
                <TubeItems
                  v-if="getActualMix?.shouldHasBase"
                  :kind="getActualMix?.kind"
                  :items="getActualMix?.baseItems"
                />
                <li
                  v-if="getActualMix?.shouldHasBase"
                  class="border-bottom border-primary opacity-20"
                />
                <TubeItems
                  :kind="getActualMix?.kind"
                  :items="getActualMix?.nonBaseItems"
                />
                <!-- Separator -->
                <li class="border-bottom border-primary opacity-20" />
              </ul>
              <Wave
                path="waveThree"
                color="text-primary-700"
                :x-center="false"
                class="relative mx-n1 mt-5"
              />
              <!-- Footer -->
              <div class="px-4 pb-5 bg-primary-700">
                <!-- Pop-up elements -->
                <ul
                  id="aside-collapse-parent"
                  class="list-unstyled mb-0 mx-n4"
                >
                  <li>
                    <!-- Button -->
                    <button
                      type="button"
                      class="btn px-4 py-3 w-100 justify-start leading-sm text-white font-medium text-base text-left rounded-0 shadow-none"
                      @click="showNutritionTable = !showNutritionTable"
                    >
                      {{ t('nutritional_values') }}
                      <i
                        v-if="showNutritionTable"
                        class="mi-triangle-u icon-10 ml-auto text-primary"
                      />
                      <i
                        v-else
                        class="mi-triangle-d icon-10 ml-auto text-primary"
                      />
                    </button>
                    <!-- Collapse -->
                    <TransitionCollapse>
                      <TubeNutritionTable
                        :mix="getActualMix"
                        :show="showNutritionTable"
                      />
                    </TransitionCollapse>
                    <!-- Separator -->
                    <div class="mx-4 border-bottom border-primary opacity-10" />
                  </li>
                  <li>
                    <!-- Button -->
                    <button
                      type="button"
                      class="btn px-4 py-3 w-100 justify-start leading-sm text-white font-medium text-base text-left rounded-0 shadow-none"
                      data-toggle="collapse"
                      data-target="#aside-collapse-2"
                      :aria-expanded="showIngredientsRatio"
                      aria-controls="aside-collapse-2"
                      @click="showIngredientsRatio = !showIngredientsRatio"
                    >
                      {{ t('proportion_of_ingredients') }}
                      <i
                        v-if="showIngredientsRatio"
                        class="mi-triangle-u icon-10 ml-auto text-primary"
                      />
                      <i
                        v-else
                        class="mi-triangle-d icon-10 ml-auto text-primary"
                      />
                    </button>
                    <!-- Collapse -->
                    <TransitionCollapse>
                      <TubeIngredienceRatio :show="showIngredientsRatio" />
                    </TransitionCollapse>
                    <!-- Separator -->
                    <div class="mx-4 border-bottom border-primary opacity-10" />
                  </li>
                </ul>
                <!-- Count -->
                <div class="form-row items-center py-3 text-white">
                  <div class="col">
                    <p class="m-0 font-medium">
                      {{ t('quantity') }}
                    </p>
                  </div>
                  <!-- Minus -->
                  <div class="col-auto">
                    <ButtonMinus
                      class="p-2"
                      icon-size="18"
                      @click="decreaseCount"
                    />
                  </div>
                  <!-- Count -->
                  <div class="col-1 text-center text-nowrap">
                    {{ getActualMix?.quantity }}
                  </div>
                  <!-- Plus -->
                  <div class="col-auto">
                    <ButtonPlus
                      class="p-2"
                      icon-size="18"
                      @click="increaseCount"
                    />
                  </div>
                </div>
                <!-- Finish -->
                <div
                  v-if="getEditedMix && !getEditedMix.isShared"
                  class="flex flex-col pt-1"
                >
                  <button
                    type="button"
                    class="btn  btn-success py-3 my-2 px-5 font-medium rounded-pill"
                    :disabled="insertionInProgress"
                    @click="addToCart"
                  >
                    <span class="block flex-grow-1">{{ t('save_mix') }}</span>
                    <i class="mi-arrow-r icon-16" />
                  </button>
                  <button
                    type="button"
                    class="btn  btn-danger py-3 px-5 font-medium rounded-pill"
                    :disabled="insertionInProgress"
                    @click="cancelEdit"
                  >
                    <span class="block flex-grow-1">{{ t('cancel_edit') }}</span>
                    <i class="mi-times icon-16" />
                  </button>
                </div>
                <div
                  v-else
                  class="flex flex-col pt-1"
                >
                  <button
                    type="button"
                    class="btn  btn-success py-3 px-5 font-medium rounded-pill"
                    :disabled="insertionInProgress"
                    @click="addToCart"
                  >
                    <span class="block flex-grow-1">{{ t('finish') }}</span>
                    <i class="mi-arrow-r icon-16" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import StickySidebar from 'sticky-sidebar-v2'
import { onMounted, onUpdated, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import ButtonMinus from '@/components/buttons/ButtonMinus.vue'
import ButtonPlus from '@/components/buttons/ButtonPlus.vue'
import TransitionCollapse from '@/components/general/BaseTransitionCollapse.vue'
import Wave from '@/components/general/BaseWave.vue'
import TubeIngredienceRatio from '@/components/mix/TubeIngredienceRatio.vue'
import TubeItems from '@/components/mix/TubeItems.vue'
import TubeNutritionTable from '@/components/mix/TubeNutritionTable.vue'
import { numberToCurrency } from '@/mixins/numberToCurrency'
import { CartService } from '@/services/cartService'
import MixDefaultNamesService from '@/services/mixDefaultNamesService'
import { useMixStore } from '@/stores/MixStore'
import { useModalStore } from '@/stores/ModalStore'
import MixValidator from '@/validators/mixValidator'

const props = defineProps({
  kind: {
    type: String,
    default: 'musli',
  },
})

const { t, locale } = useI18n()

const { openModal } = useModalStore()
const mixStore = useMixStore()
const { getEditedMix, getActualMix } = storeToRefs(mixStore)
const stickySidebar = ref()
const showIngredientsRatio = ref(false)
const showNameInput = ref(false)
const defaultMixNames = ref(MixDefaultNamesService.allNames(locale.value))
const mixName = ref(t('name_your_mix'))
const showNutritionTable = ref(false)
const insertionInProgress = ref(false)

const setMixName = (event) => {
  event.preventDefault()
  mixStore.getActualMix.name = mixName
  showNameInput.value = false
}

const addToCart = async () => {
  if (!mixStore.getActualMix) {
    openModal({
      id: 'modal-alert',
      title: t('mix_does_not_have_any_items'),
    })
    return
  }
  insertionInProgress.value = true
  const validator = new MixValidator(mixStore.getActualMix)
  mixStore.getActualMix.state = 'closed'
  if (validator.isValid()) {
    if (!mixStore.getActualMix.name) mixStore.getActualMix.name = MixDefaultNamesService.randomName(locale.value)
    const cartService = new CartService()
    const data = mixStore.getActualMix.serializeMix()
    try {
      // When editedMix object is present, updates mix. Or create new mix.
      if (getEditedMix.value && !getEditedMix.value.isShared) {
        await cartService.updateMix(
          data,
          mixStore.getActualMix.kind,
          mixStore.getActualMix.quantity,
          getEditedMix.value.hash,
        )
        mixStore.cancelEditMix(getEditedMix.value.kind)
        openModal({
          id: 'mix-added-to-cart-modal',
          title: t('mix_saved'),
          params: {
            hash: mixStore.getActualMix.hash,
          },
        })
      } else {
        await cartService.addMix(data, mixStore.getActualMix.kind, mixStore.getActualMix.quantity)
        openModal({
          id: 'mix-added-to-cart-modal',
          title: t('mix_was_added_to_cart'),
          params: {
            hash: mixStore.getActualMix.hash,
          },
        })
      }
      mixStore.resetMix(props.kind)
      insertionInProgress.value = false
    } catch (error) {
      insertionInProgress.value = false
      openModal({
        id: 'modal-alert',
        title: error.response.data.msg,
      })
    }
  } else {
    mixStore.getActualMix.state = 'open'
    const [error] = validator.getErrors()
    const message = t(`${error.key}`, error.data)
    openModal({
      id: 'modal-alert',
      title: message,
    })
    insertionInProgress.value = false
  }
}

const cancelEdit = () => {
  mixStore.cancelEditMix(getEditedMix.value.kind)
  openModal({
    id: 'mix-added-to-cart-modal',
    title: t('mix_edit_canceled'),
  })
}

const increaseCount = () => {
  mixStore.getActualMix.incrementQuantity()
}

const decreaseCount = () => {
  mixStore.getActualMix.decrementQuantity()
}

const initStickySidebar = () => {
  const ignoreFrom = 992
  const css = window.CSS || undefined
  const topGap = 200
  const topSpacing = (css && css.supports && topGap) || 15
  stickySidebar.value = new StickySidebar('#js-sticky__aside', {
    containerSelector: '#js-sticky',
    innerWrapperSelector: '#js-sticky__aside__inner',
    topSpacing,
    bottomSpacing: 15,
    minWidth: Number.parseInt(ignoreFrom) - 1,
  })
}

onMounted(() => {
  initStickySidebar()
})

onUpdated(() => {
  if (showNameInput.value) {
    const input = document.querySelector('#change-mix-name-input')
    if (input) input.focus()
  }
})
</script>

<style lang="scss" scoped>
.tubus {
	position: relative;

	&__inner {
		position: relative;
		overflow: hidden;
		z-index: 2;

		border-radius: 125px / 17px;
	}

	&::before,
	&::after {
		display: block;
		content: "";
		position: absolute;
		left: -3px;
		right: -3px;
		height: 34px;

		border-radius: 125px / 17px;
	}

	&::before {
		top: -7px;

		background-color: $white;
	}

	&::after {
		bottom: -4px;

		background-color: $gray-500;
	}
}
.sidebar {
  will-change: min-height;

  &__inner {
    transform: translate3d(0, 0, 0);
    will-change: position, transform;
  }
}
</style>


<i18n>
  {
    "cs": {
    "base_not_found": "Nejprve vložte základ mixu. Najdete ho úplně nahoře pod ikonou “základ”.",
    "cancel_edit": "Zrušit editaci",
    "currency": "Kč",
    "finish": "Dokončit",
    "first_insert_base_of_mix": "Nejprve vložte základ mixu. Najdete ho úplně nahoře pod ikonou “základ”",
    "mix_cant_have_more_than_1_base": "Mix už má základ.",
    "mix_does_not_have_any_items": "Mix je prázdný. Nejprve přidejte nějaké dobroty.",
    "mix_edit_canceled": "Editace mixu byla zrušena",
    "mix_has_less_items_than_x": "Mix má méně položek než {current_count}. Nejprve ho prosím naplňte.",
    "mix_is_not_full_enough": "Před odesláním naplňte tubus alespoň na {max_volume} % jeho objemu. Nyní je tubus zaplněn z {current_volume} %.",
    "mix_saved": "Mix byl uložen",
    "mix_was_added_to_cart": "Mix byl vložen do košíku",
    "name_appears_on_the_label": "Název se objeví na etiketě na zadní straně tubusu. Podporovány jsou pouze standardní znaky abecedy.",
    "name_your_mix": "Pojmenujte si mix",
    "nutritional_values": "Nutriční hodnoty",
    "proportion_of_ingredients": "Podíl přísad",
    "quantity": "Počet kusů",
    "save_mix": "Uložit mix",
    "tip": "TIP: Bohatší mix má alespoň 6 porcí přísad.",
    "weight_of_mix_varies": "Váha mixu se mění na základě objemu zvolených ingrediencí, aby byl tubus vždy plný. Celková váha se tedy může při vašem míchání zvyšovat i snižovat."
},
    "sk": {
    "base_not_found": "Najprv vložte základ mixu. Nájdete ho úplne hore pod ikonou \"základ\".",
    "cancel_edit": "Zrušiť editáciu",
    "currency": "€",
    "finish": "Dokončiť",
    "first_insert_base_of_mix": "Najprv vložte základ mixu. Nájdete ho úplne hore pod ikonou \"základ\"",
    "mix_cant_have_more_than_1_base": "Mix už základ má.",
    "mix_does_not_have_any_items": "Mix je prázdny. Najprv pridajte nejaké dobroty.",
    "mix_edit_canceled": "Editácia mixu bola zrušená",
    "mix_has_less_items_than_x": "Mix má menej položiek ako {current_count}. Najprv ho prosím naplňte.",
    "mix_is_not_full_enough": "Pred odoslaním naplňte tubus aspoň na {max_volume} % jeho objemu. Teraz je tubus zaplnený z {current_volume} %.",
    "mix_saved": "Mix bol uložený",
    "mix_was_added_to_cart": "Mix bol vložený do košíka",
    "name_appears_on_the_label": "Názov sa objaví na etikete na zadnej strane tubusu. Podporované sú len štandardné znaky abecedy.",
    "name_your_mix": "Pomenujte si mix",
    "nutritional_values": "Nutričné hodnoty",
    "proportion_of_ingredients": "Podiel prísad",
    "quantity": "Počet kusov",
    "save_mix": "Uložiť mix",
    "tip": "TIP: Bohatší mix má aspoň 6 porcií prísad.",
    "weight_of_mix_varies": "Váha mixu sa mení na základe objemu zvolených ingrediencií tak, aby bol tubus vždy plný. Celková váha sa preto môže pri vašom miešaní zvyšovať aj znižovať."
},
    "pl": {
    "base_not_found": "Najpierw wybierz podstawę mieszanki. Możesz ją znaleźć na samej górze pod ikoną „podstawa mieszanki”.",
    "cancel_edit": "Anuluj zmiany",
    "currency": "zł",
    "finish": "Dokończ",
    "first_insert_base_of_mix": "Najpierw włóż podstawę mixu. Znajdziesz ją na górze pod ikoną \"podstawa\"",
    "mix_cant_have_more_than_1_base": "Mix już ma podstawę.",
    "mix_does_not_have_any_items": "Mix jest pusty. Najpierw dodaj ulubione smakołyki.",
    "mix_edit_canceled": "Edycja miksu została anulowana",
    "mix_has_less_items_than_x": "Mix ma mniej składników niż {current_count}. Najpierw go uzupełnij.",
    "mix_is_not_full_enough": "Przed odesłaniem wypełnij tubę przynajmniej do {max_volume}% jej objętości. Teraz w tubie znajduje się tylko {current_volume}%.",
    "mix_saved": "Mieszanka została zapisana",
    "mix_was_added_to_cart": "Mix został włożony do koszyka",
    "name_appears_on_the_label": "Nazwa pojawi się na etykiecie z tyłu tuby. Prosimy nie używaj znaków specjalnych.",
    "name_your_mix": "Nazwij swój mix",
    "nutritional_values": "Wartości odżywcze",
    "proportion_of_ingredients": "Proporcje składników",
    "quantity": "Ilość sztuk",
    "save_mix": "Zapisz mieszankę",
    "tip": "Rada: Najsmaczniejsze mixy mają przynajmniej 6 dodatków :-)",
    "weight_of_mix_varies": "Waga mieszanki zmienia się w zależności od objętości wybranych składników, tak, aby tuba była zawsze pełna. Całkowita waga może się więc zwiększać lub zmniejszać w miarę mixowania."
},
    "hu": {
    "base_not_found": "Először válaszd ki az alapot, az oldal tetején.",
    "cancel_edit": "Kosár",
    "currency": "Ft",
    "finish": "Befejezni",
    "first_insert_base_of_mix": "Először az alapot add hozzá. A lap tetején találod meg, a müzli feliratnál.",
    "mix_cant_have_more_than_1_base": "A mixnek már van alapja.",
    "mix_does_not_have_any_items": "A mix üres. Először válassz valamilyen finomságot.",
    "mix_edit_canceled": "A keverék szerkesztése megszakítva",
    "mix_has_less_items_than_x": "A mixnek kevesebb összetevője van, mint {current_count}. Először kérlek egészítsd ki.",
    "mix_is_not_full_enough": "Kosárba helyezés előtt töltsd meg a tubus legalább {max_volume} %-át. Jelenleg a tubus {current_volume} %-ig van tele.",
    "mix_saved": "A keverék elmentve",
    "mix_was_added_to_cart": "A mix a kosárba lett helyezve",
    "name_appears_on_the_label": "Az elnevezés a doboz hátsó oldalán lévő címkén jelenik majd meg. Csak a standard ábécé betűi támogatottak.",
    "name_your_mix": "Nevezd el a mixed",
    "nutritional_values": "Tápértékadatok",
    "proportion_of_ingredients": "Az összetevők aránya",
    "quantity": "Darabszám",
    "save_mix": "Mentés",
    "tip": "TIPP: Egy gazdag mix legalább 6 összetevőből áll :-)",
    "weight_of_mix_varies": "A mix súlya a kiválasztott összetevôk térfogatától függ, annak érdekében, hogy a tubus mindig tele legyen. A végsô súly tehát nôhet vagy csökkenhet ahogy kevered."
},
    "de": {
    "base_not_found": "Wähle zunächst die Basis. Du findest sie ganz oben unter dem Symbol \"Basis\"",
    "cancel_edit": "Bearbeitung abbrechen",
    "currency": "EUR",
    "finish": "Beenden",
    "first_insert_base_of_mix": "Wähle zunächst die Basis. Diese findest du ganz oben unter dem Symbol \"Basis\"",
    "mix_cant_have_more_than_1_base": "Der Mix hat bereits eine Basis.",
    "mix_does_not_have_any_items": "Dein Mix ist leer. Füge zunächst einige Leckereien hinzu.",
    "mix_edit_canceled": "Mix bearbeiten wurde abgebrochen",
    "mix_has_less_items_than_x": "Der Mix hat weniger Artikel als {current_count}. Bitte fülle ihn zuerst.",
    "mix_is_not_full_enough": "Fülle die Dose vor dem Versand zu mindestens {max_volume} % ihres Volumens. Die Dose ist jetzt zu {current_volume} % gefüllt.",
    "mix_saved": "Der Mix wurde gespeichert",
    "mix_was_added_to_cart": "Mix wurde in den Warenkorb gelegt",
    "name_appears_on_the_label": "Der Name erscheint auf einem Etikett auf der Rückseite der Dose. Es werden nur Zeichen des Standardalphabets unterstützt.",
    "name_your_mix": "Gib deinem Mix einen Namen",
    "nutritional_values": "Nährwertangaben",
    "proportion_of_ingredients": "Der Anteil der Zutaten",
    "quantity": "Menge",
    "save_mix": "Mix speichern",
    "tip": "TIPP: Eine reichhaltiger Mix enthält mindestens 6 Portionen Zutaten :-)",
    "weight_of_mix_varies": "Das Gewicht des Mix ändert sich je nach der Menge der ausgewählten Zutaten, um sicherzustellen, dass die Dose immer voll ist. Das Gesamtgewicht kann daher beim Mischen steigen oder fallen."
},
    "at": {
    "base_not_found": "Wähle zunächst die Basis. Du findest sie ganz oben unter dem Symbol \"Basis\"",
    "cancel_edit": "Bearbeitung abbrechen",
    "currency": "EUR",
    "finish": "Beenden",
    "first_insert_base_of_mix": "Wähle zunächst die Basis. Diese findest du ganz oben unter dem Symbol \"Basis\"",
    "mix_cant_have_more_than_1_base": "Der Mix hat bereits eine Basis.",
    "mix_does_not_have_any_items": "Dein Mix ist leer. Füge zunächst einige Leckereien hinzu.",
    "mix_edit_canceled": "Mix bearbeiten wurde abgebrochen",
    "mix_has_less_items_than_x": "Der Mix hat weniger Artikel als {current_count}. Bitte fülle ihn zuerst.",
    "mix_is_not_full_enough": "Fülle die Dose vor dem Versand zu mindestens {max_volume} % ihres Volumens. Die Dose ist jetzt zu {current_volume} % gefüllt.",
    "mix_saved": "Der Mix wurde gespeichert",
    "mix_was_added_to_cart": "Mix wurde in den Warenkorb gelegt",
    "name_appears_on_the_label": "Der Name erscheint auf einem Etikett auf der Rückseite der Dose. Es werden nur Zeichen des Standardalphabets unterstützt.",
    "name_your_mix": "Gib deinem Mix einen Namen",
    "nutritional_values": "Nährwertangaben",
    "proportion_of_ingredients": "Der Anteil der Zutaten",
    "quantity": "Menge",
    "save_mix": "Mix speichern",
    "tip": "TIPP: Eine reichhaltiger Mix enthält mindestens 6 Portionen Zutaten :-)",
    "weight_of_mix_varies": "Das Gewicht des Mix ändert sich je nach der Menge der ausgewählten Zutaten, um sicherzustellen, dass die Dose immer voll ist. Das Gesamtgewicht kann daher beim Mischen steigen oder fallen."
},
    "ro": {
    "base_not_found": "Mai întâi alege baza. Le găsești în partea de sus a paginii.",
    "cancel_edit": "Anulează editarea",
    "currency": "Lei",
    "finish": "Termină",
    "first_insert_base_of_mix": "Mai întâi adaugă baza. O găsești în partea de sus a paginii, sub denumirea “musli”",
    "mix_cant_have_more_than_1_base": "Amestecul conține deja un produs de bază.",
    "mix_does_not_have_any_items": "Amestecul e gol. Mai întâi adaugă niște bunătăți.",
    "mix_edit_canceled": "Editarea mixului a fost anulată",
    "mix_has_less_items_than_x": "Mixul are mai puține articole decât {current_count}. Vă rugăm să îl umpleți mai întâi.",
    "mix_is_not_full_enough": "Înainte de adăugarea în coș umple tubul la cel puțin {max_volume} % din volumul lui. Momentan {current_volume} % din tub e plin.",
    "mix_saved": "Amestecul a fost salvat",
    "mix_was_added_to_cart": "Mixul a fost adăugat în coș",
    "name_appears_on_the_label": "Numele apare pe eticheta din spate a cutiei. Sunt acceptate doar caractere din alfabetul standard.",
    "name_your_mix": "Denumire mix",
    "nutritional_values": "Valori nutriționale",
    "proportion_of_ingredients": "Proporția ingredientelor",
    "quantity": "Număr bucăți",
    "save_mix": "Salvează amestecul",
    "tip": "SFAT: Un amestec mai bogat are cel puțin 6 porții de ingrediente.",
    "weight_of_mix_varies": "Greutatea mixului se modifică în funcție de volumul ingredientelor selectate, astfel încât tubul să fie întotdeauna plin. Greutatea totală poate crește sau scădea pe măsură ce amesteci."
},
    "fr": {
    "base_not_found": "Commencez par ajouter la base du mix. Vous la trouverez tout en haut sous l’icône « base ».",
    "cancel_edit": "Annuler la modification",
    "currency": "€",
    "finish": "Terminer",
    "first_insert_base_of_mix": "Commencez par ajouter la base du mix. Vous la trouverez tout en haut sous l’icône « base ».",
    "mix_cant_have_more_than_1_base": "Le mix a déjà une base.",
    "mix_does_not_have_any_items": "Le mix est vide. Ajoutez d’abord quelques gourmandises.",
    "mix_edit_canceled": "L’édition du mix a été annulée",
    "mix_has_less_items_than_x": "Mix contient moins d'articles que{current_count}. Veuillez d'abord le remplir.",
    "mix_is_not_full_enough": "Avant l'expédition, remplissez le tube à au moins {max_volume} % de son volume. Maintenant, le tube est rempli à partir de%. {current_volume}",
    "mix_saved": "Le mix a été enregistré",
    "mix_was_added_to_cart": "Le mix a été ajouté au panier",
    "name_appears_on_the_label": "Le nom figure sur l'étiquette au dos du tube. Seuls les caractères alphabétiques standard sont pris en charge.",
    "name_your_mix": "Donnez un nom à votre mix",
    "nutritional_values": "Valeurs nutritionnelles",
    "proportion_of_ingredients": "Proportion d'ingrédients",
    "quantity": "Nombre de pièces",
    "save_mix": "Enregistrer le mix",
    "tip": "ASTUCE : Un mix plus riche contient au moins 6 portions d’ingrédients.",
    "weight_of_mix_varies": "Le poids du mélange varie en fonction du volume des ingrédients sélectionnés, de sorte que le tube soit toujours plein. Ainsi, le poids total peut à la fois augmenter et diminuer au fur et à mesure que vous créez."
}
  }
</i18n>
